import React from 'react';
import { useStateValue } from "../StateProvider";
import "./GenreFilter.css";

function GenreFilter() {
  const [{ selectedGenreFilter }, dispatch] = useStateValue();

  // Genre options - matching the list from SongConfirmation.js
  const genres = [
    "All Genres",
    "Avant Garde",
    "Blues",
    "Classical",
    "Country",
    "Easy Listening",
    "Electronic",
    "Folk",
    "Hip-Hop/Rap",
    "Indie Rock",
    "Instrumental",
    "Jazz",
    "Kids/Family",
    "Latin",
    "LoFi",
    "Metal",
    "Punk",
    "Post Rock",
    "Alternative Rock",
    "Punk Rock",
    "New Age",
    "Pop",
    "R&B/Soul",
    "Reggae",
    "Rock",
    "Spiritual",
    "None"
  ];

  const handleGenreChange = (e) => {
    const newGenre = e.target.value;
    console.log('Genre filter changed to:', newGenre);
    dispatch({
      type: "SET_SELECTEDGENREFILTER",
      selectedGenreFilter: newGenre,
    });
  };

  // Handle clicks on the wrapper - force focus on select
  const handleWrapperClick = (e) => {
    // If clicking on the wrapper (not the select itself), focus the select
    if (e.target !== e.currentTarget.querySelector('select')) {
      const select = e.currentTarget.querySelector('select');
      if (select) {
        select.focus();
        // Force the dropdown to open
        select.click();
      }
    }
  };

  return (
    <div className="genre-filter-container">
      <label htmlFor="genre-filter" className="genre-filter-label">
        <span role="img" aria-label="music">🎸</span> Filter by Genre:
      </label>
      <div className="genre-filter-wrapper" onClick={handleWrapperClick}>
        <select
          id="genre-filter"
          value={selectedGenreFilter}
          onChange={handleGenreChange}
          className="genre-filter-select"
        >
          {genres.map((genre) => (
            <option key={genre} value={genre}>
              {genre}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default GenreFilter;
